const defaultEmbedTypes = [{
  name: 'Embed the video on my profile',
  value: 'embed',
  ratio: 16 / 9
}];
const YOUTUBE_REGEX = /^https?\:\/\/(?:www\.youtube(?:\-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*\&)?vi?=|\&vi?=|\?(?:.*\&)?vi?=)([^#\&\?\n\/<>"']*)/i;
const TWITCH_CHANNEL_REGEX = /^(http|https):\/\/(www\.)?twitch.tv\/+((#)?[a-zA-Z0-9][\w]{2,24})$/i;
const TWITCH_VIDEO_REGEX = /^[(http|https):\/\/(www\.)?twitch.tv\/videos\/]+([0-9]{5,})/i;
const VIMEO_VIDEO_REGEX = /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/i;
const FACEBOOK_VIDEO_REGEX = /(?:http|https)?:\/\/(?:www.|web.|m.)?facebook.com\/(?:video.php\?v=\d+|photo.php\?v=\d+|\?v=\d+)|\S+\/videos\/((\S+)\/(\d+)|(\d+))\/?/i;
function getYoutubeId(url) {
  const match = url.match(YOUTUBE_REGEX);
  return match && match[1].length == 11 ? match[1] : false;
}
function getTwitchChannelUsername(url) {
  const match = url.match(TWITCH_CHANNEL_REGEX);
  return match ? match[3] : false;
}
function getTwitchVideoId(url) {
  const match = url.match(TWITCH_VIDEO_REGEX);
  return match ? match[1] : false;
}
function getVimeoVideoId(url) {
  const match = url.match(VIMEO_VIDEO_REGEX);
  return match ? match[4] : false;
}
const YOUTUBE_VIDEO_OPTIONS = {
  id: 'youtube',
  name: 'Youtube',
  urlPatterns: [YOUTUBE_REGEX],
  getId: getYoutubeId,
  embedTypes: defaultEmbedTypes,
  icon: 'PlayCircleOIcon',
  type: 'video'
};
const TWITCH_CHANNEL_OPTIONS = {
  id: 'twitch_channel',
  name: 'Twitch',
  urlPatterns: [TWITCH_CHANNEL_REGEX],
  getId: getTwitchChannelUsername,
  embedTypes: [{
    name: 'Embed my Twitch channel',
    value: 'embed',
    ratio: 16 / 9
  }, {
    name: 'Embed my Twitch chat',
    value: 'embed_chat',
    ratio: 4 / 3
  }, {
    name: 'Embed my Twitch channel and chat',
    value: 'embed_channel_chat',
    ratio: 3 / 4
  }],
  icon: 'PlayCircleOIcon',
  type: 'video'
};
const TWITCH_VIDEO_OPTIONS = {
  id: 'twitch_video',
  name: 'Twitch',
  urlPatterns: [TWITCH_VIDEO_REGEX],
  getId: getTwitchVideoId,
  embedTypes: defaultEmbedTypes,
  icon: 'PlayCircleOIcon',
  type: 'video'
};
const VIMEO_VIDEO_OPTIONS = {
  id: 'vimeo_video',
  name: 'Vimeo',
  urlPatterns: [VIMEO_VIDEO_REGEX],
  getId: getVimeoVideoId,
  embedTypes: defaultEmbedTypes,
  icon: 'PlayCircleOIcon',
  type: 'video'
};
const FACEBOOk_VIDEO_OPTIONS = {
  id: 'facebook_video',
  name: 'Facebook',
  urlPatterns: [FACEBOOK_VIDEO_REGEX],
  getId: url => url,
  embedTypes: defaultEmbedTypes,
  icon: 'PlayCircleOIcon',
  type: 'video'
};
const VIDEO_OPTIONS = [YOUTUBE_VIDEO_OPTIONS, TWITCH_CHANNEL_OPTIONS, TWITCH_VIDEO_OPTIONS, VIMEO_VIDEO_OPTIONS, FACEBOOk_VIDEO_OPTIONS];
const videoUrlPatterns = VIDEO_OPTIONS.reduce((accum, option) => {
  accum.push(...option.urlPatterns);
  return accum;
}, []);
function getVideoType(url) {
  if (!url) return undefined;
  return VIDEO_OPTIONS.find(option => {
    for (let i = 0; i < option.urlPatterns.length; i++) {
      const pattern = option.urlPatterns[i];
      if (pattern.test(url)) return true;
    }
    return false;
  });
}
export { FACEBOOK_VIDEO_REGEX, FACEBOOk_VIDEO_OPTIONS, TWITCH_CHANNEL_OPTIONS, TWITCH_CHANNEL_REGEX, TWITCH_VIDEO_OPTIONS, TWITCH_VIDEO_REGEX, VIDEO_OPTIONS, VIMEO_VIDEO_OPTIONS, VIMEO_VIDEO_REGEX, YOUTUBE_REGEX, YOUTUBE_VIDEO_OPTIONS, getTwitchChannelUsername, getTwitchVideoId, getVideoType, getVimeoVideoId, getYoutubeId, videoUrlPatterns };